import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSites } from 'store'
import useActions from '../use-actions'

const Logout = () => {
  const navigate = useNavigate()
  const { logout } = useActions()
  const [, setSites] = useSites()

  useEffect(() => {
    ;(async () => {
      await logout()
      setSites(prev => ({...prev, focus: null, selected: [], accounts: []}))
      navigate('/auth/login')
    })()
  }, [])
  return null
}

export default Logout
